<template>
  <el-dialog v-bind="$attrs" :show-close="isShowClose" :close-on-click-modal="false" class="v-dialog" v-on="$listeners"
    :append-to-body="true" @close="close" @closed="closed">
    <p v-if="ctxMsg" class="ctx-msg" v-html="ctxMsg"></p>
    <slot></slot>
    <div slot="footer" class="v-dialog__footer">
      <slot name="footer_before"></slot>
      <div v-if="isCanShow" class="cancel-btn">
        <v-button :name="canText" size="small" @click="close" />
      </div>
      <slot name="footer_middle"></slot>
      <div v-if="isConShow" class="confirm-btn">
        <v-button :name="conText" type="normal-bg" size="small" @click="$emit('confirm')" />
      </div>
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '@/utils/i18n';

export default {
  name: 'VDialog',
  inheritAttrs: false,
  props: {
    ctxMsg: {
      type: String,
      default: '',
    },
    isCanShow: {
      type: Boolean,
      default: true,
    },
    canText: {
      type: String,
      default: i18n.t('common.cancel'),
    },
    isConShow: {
      type: Boolean,
      default: true,
    },
    conText: {
      type: String,
      default: i18n.t('common.ok2'),
    },
    isShowClose: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    close() {
      this.$emit(`update:visible`, false);
      this.$emit('close');
    },
    closed() {
      this.$emit('closed');
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/confirm.scss';

.v-dialog {
  width: 100%;
  font-weight: 500;

  .el-dialog {
    position: absolute;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin-top: 0 !important;
    border-radius: 4px;

    .ctx-msg {
      font-size: $font16;
      color: $headerText;
      line-height: $font24;
    }

    .el-dialog__body {
      font-size: $font16;
      color: $headerText;
      padding: 16px 32px;
      max-height: calc(100vh - 180px);
      overflow-x: hidden;
      overflow-y: auto;
      @include scrollBar;

      .el-table__empty-text {
        line-height: 60px;
      }
    }

    .el-dialog__footer {
      padding: 16px 32px;
      @include borderTop($bottomBg);
    }
  }

  &__footer {
    @include flex;
    justify-content: flex-end;

    .cancel-btn {
      margin-right: 12px;
    }
  }
}
</style>
